import exception from './vi-VN/exception';
import form from './vi-VN/form';
import globalHeader from './vi-VN/globalHeader';
import login from './vi-VN/login';
import menu from './vi-VN/menu';
import settingDrawer from './vi-VN/settingDrawer';
import pwa from './vi-VN/pwa';
import order from './vi-VN/order';
import profile from './vi-VN/profile';
import measurement from './vi-VN/measurement';
import global from './vi-VN/global';
import quickOrder from './vi-VN/quickOrder';

export default {
  'navBar.lang': 'Languages',
  'layout.user.link.help': 'Help',
  'layout.user.link.privacy': 'Privacy',
  'layout.user.link.terms': 'Terms',
  'home.introduce': 'introduce',
  'forms.basic.title': 'Basic form',
  'forms.basic.description':
    'Form pages are used to collect or verify information to users, and basic forms are common in scenarios where there are fewer data items.',
  ...exception,
  ...form,
  ...globalHeader,
  ...login,
  ...menu,
  ...settingDrawer,
  ...pwa,
  ...order,
  ...profile,
  ...measurement,
  ...global,
  ...quickOrder,
};
